import { Modal } from '@material-ui/core';

import { useSOCancelDialog, useSOCancelDialogLang } from './hooks';
import makeClasses from './SOCancelDialog.style';

interface Props {
  orderId: number;
  open: boolean;
  onClose: () => void;
  onCanceled: () => void;
  onFailed: () => void;
}

export function SOCancelDialog({
  orderId,
  open,
  onClose,
  onCanceled,
  onFailed,
}: Props) {
  const classes = makeClasses();
  const lang = useSOCancelDialogLang();
  const { handleSubmit, isLoading } = useSOCancelDialog({
    orderId,
    onCanceled,
    onFailed,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{ className: classes.backdrop }}
      aria-labelledby='so-cancel-dialog-title'
    >
      <div className={classes.paper}>
        <header className={classes.header}>
          <h2 id='so-cancel-dialog-title' className={classes.title}>
            {lang.confirmTitle}
          </h2>
        </header>
        <main className={classes.body}>
          <p>{lang.confirmDescription}</p>
        </main>
        <footer className={classes.footer}>
          <button type='button' className={classes.btnBack} onClick={onClose}>
            {lang.confirmBack}
          </button>
          <button
            type='button'
            className={classes.btnSubmit}
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {lang.confirmSubmit}
          </button>
        </footer>
      </div>
    </Modal>
  );
}
